<app-advanced-search *ngIf="!hideSearch" (newQuery)="newQuery.emit($event)" [columns]="columnFields"></app-advanced-search>
<app-simple-table *ngIf="isTableView; else gridView" [availableColumns]="columns" [tableId]="tableId"
                  [tableDataContainer]="cards" (rowClicked)="cardClicked.emit($event)"
                  (rowContextClicked)="cardContextClicked.emit($event)"
                  [sortColumnId]="defaultSortColumn"
                  [sortDirection]="defaultSortDirection"
                  [isValid]="isValid"
                  (editableFieldChanged)="cardInputFieldChanged.emit($event)"
                  [overrideClick]="overrideClick"
                  [removableCards]="removableCards"
                  [addCardsToDeck]="addCardsToDeck"
                  [addCardsToInventory]="addCardsToInventory"
                  (cardActionTaken)="cardActionTaken.emit()"></app-simple-table>
<ng-template #gridView>
    <app-card-grid *ngIf="cards" [items]="cards" [GridColumnCount]="8" (gridColumnsSet)="onCardGridColumnsSet($event)"
                   [isValid]="isValid"
                   [removableCards]="removableCards"
                   [addCardsToDeck]="addCardsToDeck"
                   [addCardsToInventory]="addCardsToInventory"
                   (cardActionTaken)="cardActionTaken.emit()"
                   [overrideClick]="overrideClick"
                   (cardClicked)="cardClicked.emit($event)"
                   (cardContextClicked)="cardContextClicked.emit($event)"></app-card-grid>
</ng-template>
<mat-progress-bar *ngIf="isLoadingResults" mode="query"></mat-progress-bar>
<mat-paginator *ngIf="!hidePaginator" [length]="totalSize || cards?.length || 0"
               [pageSizeOptions]="pageSizeOptions"
               [pageIndex]="defaultPageIndex"
               [pageSize]="defaultPageSize" showFirstLastButtons></mat-paginator>
<div *ngIf="hidePaginator" class="paginator-placeholder"></div>
<div class="paginator-left">
    <mat-slide-toggle class="slide-toggle" [checked]="!isTableView" (change)="onCardViewSelectorChanged()">Grid View
    </mat-slide-toggle>
    <mat-slide-toggle class="subsequent-slide-toggle"
                      *ngIf="showOwnedCardsSelector"
                      [checked]="false"
                      (change)="showOwnedCardsSelectorChanged.emit($event)">Owned Cards
    </mat-slide-toggle>
    <mat-hint class="drag-hint" *ngIf="showDragHint">Hint: Drag rows (or cards in grid view) to your deck/inventory to add them!</mat-hint>
</div>
